export default __webpack_public_path__ + "static/media/claims-assisted.d07ea9b83d2159eaed25122b262ae5df.d07ea9b8.svg";